import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom-v5-compat";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { ListError } from "@tenant/ui";
import clsx from "clsx";
import { useFetchHotels } from "../../hooks";
import { HotelsAvailabilitySelectors } from "../../store";
import defaultStyles from "./HotelListError.module.scss";

export const HotelListError = ({
  className,
  children,
}: PlatformComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelListError;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  const fetchHotels = useFetchHotels();

  const availabilityRequest = useSelector(
    HotelsAvailabilitySelectors.getCurrentAvailabilityRequest
  );

  const navigate = useNavigate();

  return (
    <ListError
      className={clsx(block, className)}
      onTapReload={() =>
        availabilityRequest != null
          ? fetchHotels(availabilityRequest)
          : navigate(0)
      }
    >
      {children}
    </ListError>
  );
};
